import React from "react";
import cn from "classnames";
import { FaChevronLeft } from "react-icons/fa";

export const StepHeader = ({
  className,
  children,
}: {
  className?: string;
  children: React.ReactNode;
}) => {
  return <div className={cn("text-3xl font-bold", className)}>{children}</div>;
};

export const StepContainer = ({
  style,
  className,
  children,
  backgroundImage,
  ...props
}: {
  style?: React.CSSProperties;
  className?: string;
  children: React.ReactNode;
  backgroundImage?: React.ReactNode;
}) => {
  return (
    <>
      {backgroundImage}
      <div
        className={cn("flex mt-8 mx-auto relative", className)}
        style={style}
        {...props}
      >
        {children}
      </div>
    </>
  );
};

export const StepBack = ({
  className,
  ...props
}: React.ComponentProps<"button">) => {
  return (
    <button
      className={cn(
        "flex items-center justify-center rounded-full outline-none focus:outline-none w-9 h-9",
        "bg-gray-200 hover:bg-gray-300 text-gray-600 transition-colors",
        className
      )}
      {...props}
    >
      <FaChevronLeft />
    </button>
  );
};
